// 国际化英文表达部分
export default {
  title: {
    map: "Map",
    marking: "Marking",
    plot: "Plot",
    devicePositioning: "Locate",
    electronicFence: "Fence",
    warningDetails: "Alert Details",
  },
  common: {
    cancel: "Cancel",
    confirm: "OK",
    save: "Save",
    delete: "Delete",
    close: "Close",
    satellite: "Satellite",
    layer: "Standard",
    saving: "Saving...",
    saveSuccess: "Save Success",
    deleteTips: "Delete Tips",
    deleting: "Deleting...",
    deleteSuccess: "Delete Success",
    tips: "Tips",
    loading: "Loading...",
    modify: "Modify",
    revoke: "Revoke",
    yes: "Yes",
    no: "No",
    selectAll: "Select All",
    editing: "Editing",
    editSuccess: "Edit Success",
  },
  form: {
    keywordPlaceholder: "Enter keyword",
    tracking: "Mark Device",
    selectDevice: "Select Device",
    park: "Park",
    deviceType: "Type",
    deviceTypePlaceholder: "Select type",
    site: "Site",
    sitePlaceholder: "Select site",
    mac: "MAC",
    macPlaceholder: "Select MAC",
    latLon: "Lat/Lon",
    keyWordDeviceName: "Enter device name",
    fenceName: "Fence Name",
    fenceNamePlaceholder: "Enter fence name",
    selectSiteConfirm: "Selected {num} sites",
  },
  page: {
    AMap: "AMap",
    TMap: "Tencent Map",
    BMap: "Baidu Map",
    devicePositioning: {
      deviceName: "Device",
      lon: "Longitude",
      lat: "Latitude",
      altitude: "Altitude",
      altitudeUnit: "m",
      btnText: "Track",
    },
    electronicFence: {
      marking: "Marking",
    },
  },
  warning: {
    noPlot: "No plot info, please reselect.",
    latLonError: "Failed to get location, please retry.",
    noSite: "No sites for this type",
    noMac: "No MAC for this site",
    repeatedDotting: "Device already marked!",
    mapError: "Map not loaded. Please initialize map first.",
    noPermission: "No permission to operate!",
    noMobileIrrigationSite: "No mobile irrigation site info, please contact admin.",
    pleaseDrawFence: "Please draw a fence with at least three points.",
    noFenceSite: "Fence must bind at least one device site.",
  },
  tips: {
    deleteTrackInfo: "Delete {name} marker?",
    deviceRefreshPositioning: "Refresh {name} positioning?",
    openMapSoftware: "Open {software}?",
    cancelMarking: "Cancel marking?",
    saveMarking: "Save marking?",
    confirmFence: "Confirm fence?",
    deleteFence: "Delete fence {name}?",
    editFence: "Edit fence {name}?",
    toLocationPage: "Go to navigation page?",
  },
  empty: {
    featureEmpty: "Coming soon",
  },
};
